import { createFileRoute } from '@tanstack/react-router'
import { Result } from 'antd'
import z from 'zod'

import { useLocaleName } from '@/stores/setting.store.ts'

export const Route = createFileRoute('/auth/success')({
  component: RouteComponent,
  validateSearch: z.object({
    success_type: z.enum(['register_success', 'reset_password_success']),
  }),
})

function RouteComponent() {
  const locale = useLocaleName()
  const message = messages[locale]
  const search = Route.useSearch()

  return <Result status="success" title={message[search.success_type]} subTitle="" extra={[]} />
}

const messages = {
  'zh-CN': {
    register_success: '注册成功',
    reset_password_success: '密码重置成功',
  },
  'en-GB': {
    register_success: 'Registration successful',
    reset_password_success: 'Password reset successful',
  },
  'cy-GB': {
    register_success: "Cofrestru'n llwyddiannus",
    reset_password_success: 'Cynewidpwd llwyddiannus',
  },
}
